<template lang="pug">
  div(v-cloak)
    v-layout(row wrap)
      v-flex(xs12 md8 offset-md2 lg4 offset-lg4)

        v-card.ma-1
          v-card-title.primary.white--text
            | 準備
          v-card-text
            v-btn(
              raised
              color="primary"
              @click="startInput"
              v-show="!progressing"
              )
              v-icon play_circle_outline
              span {{$t('order.prepare.start_input')}}

            v-btn(
              raised
              color="primary"
              @click="toInput"
              v-show="progressing"
              )
              v-icon create
              span {{$t('order.prepare.to_input')}}

            v-btn(
              flat
              color="warning"
              warning
              @click="abandonInput"
              v-show="isNewOrder && progressing"
              )
              v-icon close
              span {{$t('order.prepare.abandon_input')}}

            v-alert(outline type="warning" value="true" v-if="progressing")
              span {{$t('order.prepare.progressing_message')}}

            v-text-field(
              v-if="progressing"
              type="text"
              :label="$t('order.prepare.order_date.name')"
              :hint="$t('order.prepare.order_date.hint_readonly')"
              :value="prepare.order_date|date"
              autocapitalize="off"
              prepend-icon="schedule"
              readonly
              )
            v-menu(
              v-else
              lazy
              :close-on-content-click="false"
              v-model="orderDatePicker"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-right="40"
              max-width="290px"
              min-width="290px"
              )
              v-text-field(
                :label="$t('order.prepare.order_date.name')"
                :hint="$t('order.prepare.order_date.hint')"
                slot="activator"
                :value="prepare.order_date|date"
                prepend-icon="schedule"
                readonly
                )
              v-date-picker(
                @input="setPrepare({'order_date': $event})"
                :value="prepare.order_date"
                )

            div(v-if="selection !== null")
              v-select(
                :items="selection.sellers"
                :label="$t('order.summary.seller.name')"
                :hint="$t('order.summary.seller.hint')"
                :value="summary.seller"
                @input="setSummary({'seller': $event})"
                ref="seller"
                :rules="[rules.required]"
                item-text="options.sign"
                item-value="id"
                return-object
                :no-data-text="$t('_rules.no_data_text')"
                prepend-icon="perm_identity"
                )
              v-select(
                :items="selection.inputters"
                :label="$t('order.summary.inputter.name')"
                :hint="$t('order.summary.inputter.hint')"
                :value="summary.inputter"
                @input="setSummary({'inputter': $event})"
                ref="inputter"
                :rules="[rules.required]"
                item-text="options.sign"
                item-value="id"
                return-object
                :no-data-text="$t('_rules.no_data_text')"
                prepend-icon="perm_identity"
                )
              v-autocomplete(
                :items="selection.customers"
                :label="$t('order.summary.customer.name')"
                :hint="$t('order.summary.customer.hint')"
                :value="summary.customer"
                @input="setSummary({'customer': $event})"
                ref="customer"
                :rules="[rules.required]"
                item-text="display"
                item-value="id"
                return-object
                prepend-icon="perm_identity"
                :no-data-text="$t('_rules.no_data_text')"
                append-icon="refresh"
                @click:append="reloadCustomers"
                )
              span.remarks
                span 顧客担当者登録は
                a(@click="jumpToAddCustomer") こちら
                span で登録後、リフレッシュボタン
                v-icon refresh
                span を押してください。
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import rules from '@/common/mixins/rules'

export default {
  data () {
    return {
      orderDatePicker: false,
      selection: null
    }
  },
  mixins: [rules],
  created () {
    let self = this
    self.$ajax.get('order/summary_selection').then(function (response) {
      self.selection = response.data.selection
      if (self.isNewOrder) {
        self.setSummary(response.data.initial)
      }
    })
  },
  computed: {
    ...mapGetters('app/order', [
      'isNewOrder',
      'prepare',
      'progressing',
      'summary'
    ])
  },
  methods: {
    ...mapActions('app/order', [
      'activateTab',
      'startProgress',
      'setPrepare',
      'setSummary',
      'setInput'
    ]),
    startInput () {
      let self = this
      if (self.hasRuleError()) {
        self.$toastr.warning(self.$t('_rules.invalidate_message'))
        return true
      }
      self.activateTab('input')
      self.startProgress()
    },
    toInput () {
      this.activateTab('input')
    },
    abandonInput () {
      // FIXME
      this.$router.go()
    },
    reloadCustomers () {
      let self = this
      self.$ajax.get('order/summary_selection').then(function (response) {
        self.selection.customers = response.data.selection.customers
      })
    },
    jumpToAddCustomer () {
      let v = window.open()
      v.location.href = '/customer'
    }
  }
}
</script>

<style scoped lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/pages/Order/Components/Prepare.vue